const type = 'RESET_PRE_PRAID_TIMELINE_ITEMS';

const resetPrePaidTimelineItems = () => ({
  type,
});

export { type };
export default resetPrePaidTimelineItems;
